<template>
  <base-input :rules="internalRules" :errors="errors">
    <div
      :class="[
        inline
          ? 'tw-relative tw-mt-1'
          : `tw-relative tw-border tw-rounded-md focus-within:tw-ring-1 tw-ring-0 tw-flex tw-items-center tw-transition-all tw-ease-in-out tw-duration-100 tw-bg-white tw-z-auto tw-mt-1 focus-within:tw-ring-${focusColor} focus-within:tw-border-${focusColor} tw-border-${borderColor}`,
      ]"
    >
      <label :class="['tw-absolute tw--top-2 tw-left-2 tw--mt-px tw-inline-block tw-px-1 tw-bg-white tw-text-xs tw-font-normal tw-z-10', `tw-text-${labelColor}`]" v-if="label">{{
        label
      }}</label>
      <datepicker
        :value="value"
        :inline="inline"
        :typeable="typeable"
        @input="handleInput($event)"
        :input-class="
          `form-input tw-flex-grow tw-block tw-w-full tw-border-0 tw-text-gray-900 focus:tw-ring-0 tw-font-light tw-px-3 tw-py-2 tw-rounded-md tw-placeholder-${placeholderColor} sm:tw-text-${size}`
        "
        wrapper-class="tw-border-gray-300 tw-w-full"
        :placeholder="placeholder"
        @closed="validate"
        calendar-class="tw-z-0"
        :format="customFormatter"
        :disabled-dates="computedDisabledDates"
        :initial-view="initialView"
      />
    </div>
  </base-input>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import validatable from "@/mixins/validatable";

export default {
  mixins: [validatable],
  components: {
    Datepicker,
  },
  props: {
    value: [Date, String],
    label: String,
    placeholder: String,
    typeable: { type: Boolean, default: true },
    inline: { type: Boolean, default: false },
    size: {
      type: String,
      default: "sm",
    },
    disabledDates: Object,
    minDate: [Date, String],
    initialView: {
      type: String,
      default: "day",
    },
  },
  computed: {
    focusColor() {
      return this.hasError ? "red-500" : "primary-500";
    },
    borderColor() {
      return this.hasError ? "red-500" : "gray-200";
    },
    labelColor() {
      return this.hasError ? "red-500" : "gray-900";
    },
    placeholderColor() {
      return this.hasError ? "red-400" : "gray-500";
    },
    computedDisabledDates() {
      let result = this.disabledDates ? { ...this.disabledDates } : {};

      if (this.minDate) {
        const minDateObj = this.convertToDate(this.minDate);
        result.to = moment(minDateObj)
          .startOf("day")
          .toDate();
      }
      return Object.keys(result).length > 0 ? result : undefined;
    },
  },
  methods: {
    handleInput(event) {
      this.validate();
      this.$emit("input", event);
    },
    reset() {
      this.isResetting = true;
      this.$emit("input", null);
    },
    customFormatter(date) {
      return moment(date).format("MMMM D, YYYY");
    },
    convertToDate(dateValue) {
      if (!dateValue) return null;
      if (dateValue instanceof Date) return dateValue;
      if (typeof dateValue === "string") {
        // Parse as YYYY-MM-DD format
        return moment(dateValue, "YYYY-MM-DD").toDate();
      }
      return dateValue;
    },
  },
};
</script>

<style>
.vdp-datepicker__calendar {
  @apply tw-border-gray-200 !important;
}
.vdp-datepicker__calendar .cell:hover {
  @apply tw-rounded tw-border-primary tw-ring-1 tw-ring-primary !important;
}
.vdp-datepicker__calendar .cell.selected {
  @apply tw-rounded tw-bg-primary-50 tw-text-primary !important;
}
</style>
